// extracted by mini-css-extract-plugin
export default {"root__container":"styles_root__container__BkA4q"};